import { gql } from '@apollo/client';

const EFA_CONTACT_PULL = gql`
  query EFAContactPull($applicationId: String!, $vendor: BureauVendor!) {
    pullEfaStatements(applicationId: $applicationId, vendor: $vendor) {
      requestId
      statements
    }
  }
`;

const BUREAU_FRAUD_SIGNALS = gql`
  query BureauFraudSignals($documentId: String!, $vendor: BureauVendor!) {
    bureauFraudSignals(documentId: $documentId, vendor: $vendor) {
      consumerStatements
    }
  }
`;

export { EFA_CONTACT_PULL, BUREAU_FRAUD_SIGNALS };
